export const parseIntIfNumber = (value: string): string | number => {
  if (/^[0-9]*$/.test(value)) {
    return Number.parseInt(value);
  }
  return value;
};
